import html2canvas from 'html2canvas';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import svgLogo from 'images/logos/linearb-logo.svg';
import { Flex } from 'components/base/layout-components';

const PoweredBy = styled(Flex)`
  color: ${getColor('shuttleGray')};
`;

const Logo = styled.img`
  height: 100%;
  width: 7rem;
  padding-left: 1rem;
  margin-top: 1rem;
`;

const ExportFileWrapper = styled.div`
  position: absolute;
  pointer-events: none;
  opacity: 0;
  min-width: 1500px;
  width: 100vw;
  top: 0;
  left: -100vw;
`;

const FullSizeWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const DataWrapper = styled.div`
  [data-html2canvas-notice='true'] {
    display: none;
  }

  [data-html2canvas-hide='true'] {
    visibility: visible;
  }
`;

const ExportDataWrapper = styled.div`
  background: ${getColor('catskillWhite')};
  padding: 2rem 2rem 0 2rem;

  [data-html2canvas-notice='true'] {
    display: unset;
  }

  [data-html2canvas-hide='true'] {
    visibility: hidden;
  }

  p.multiLineEllipsis {
    display: inline-block !important;
  }

  p {
    overflow: unset;
  }

  #select {
    display: block;

    .avatar {
      p {
        margin-top: -1rem;
      }
    }

    p {
      margin-top: -1rem;
    }
  }

  .maxHeight {
    max-height: fit-content;
  }
`;

const ExportPoweredBy = () => (
  <div>
    <PoweredBy pt='medium' pb='x-medium' items='center' justify='center'>
      Powered by <Logo src={svgLogo} />
    </PoweredBy>
  </div>
);

const downloadFile = (uri, fileName) => {
  const link = document.createElement('a');
  const exportContentElement = document.querySelector('#exportContent');
  if (typeof link.download === 'string') {
    link.href = uri;
    link.download = fileName;

    // Firefox requires the link to be in the body
    document.body.appendChild(link);

    // simulate click
    link.click();

    // remove the link when done
    document.body.removeChild(link);

    // remove all elements from exportContent
    exportContentElement.replaceChildren();
  } else {
    window.open(uri);
  }
};

export const exportPNG = fileName => {
  const exportElement = document.querySelector('#exportRoot');
  // clone and append all elements to exportContent
  const containerElement = document.querySelector('#containerRoot');
  const exportContentElement = document.querySelector('#exportContent');
  const containerChildren = containerElement.childNodes;
  containerChildren.forEach(item => {
    const cln = item.cloneNode(true);
    exportContentElement.appendChild(cln);
  });
  html2canvas(exportElement).then(canvas => {
    downloadFile(
      canvas.toDataURL(),
      `${fileName || 'file' + new Date().toISOString()}.png`
    );
  });
};

const ExportFile = ({ children }) => {
  return (
    <FullSizeWrapper>
      <DataWrapper id='containerRoot'>{children}</DataWrapper>
      <ExportFileWrapper>
        <ExportDataWrapper id='exportRoot'>
          <div id='exportContent'></div>
          <ExportPoweredBy />
        </ExportDataWrapper>
      </ExportFileWrapper>
    </FullSizeWrapper>
  );
};
export default ExportFile;
